export default __webpack_public_path__ + "static/media/apple-pay-mark.a8842a6b.svg";